import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import dynamic from 'next/dynamic';

import Checkers from '../../../../../../helpers/class/Checkers';
import CustomModal from '../../../../../CustomModal';
import GalleryItem from '../../../partials/gallery/GalleryItem';
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";
import Methods from "../../../../../../helpers/class/Methods";
const ModalPropertyImages = dynamic( () => import( '../../../partials/modals/ModalPropertyImages' ), { ssr: false });

export const FeaturedImages = ( props ) => {

  const builderPropertiesGalleryMode = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_gallery_view_mode'));

  const [show, setShow] = useState(false);
  const [modalState, setModalState] = useState("close");

  const handleShow = (state) => {
    setShow(true);
    setModalState(state);
  }

  const handleHide = () => {
    setShow(false);
    setModalState("close");
  }

  const config = {disconnectOnLeave: false};
  const options = {};
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
      myRef,
      options,
      config,
      props
  );

  let viewPortResult = null;

  if (!inViewport) {
    viewPortResult =
        <div ref={myRef}>
          <Skeleton height={355} className="col-12 b-rad-lg"/>
        </div>
    ;
  } else {
    viewPortResult =
        <>
          <div className="col-12">
            <div className="row full-width no-margin">
              {props.images.map((item, key) =>
                  <GalleryItem fancybox={'featured_images'} key={item.image_id.toString()} index={key}
                               image={item.image} imageThumb={item.image_thumb}/>
              )}
              {
                  props.images_count > 6 &&
                  Checkers.objChildExists(props, 'all_images') && Checkers.isValidArray(props.all_images) && props.all_images.length > 6 &&
                  props.all_images.slice(6).map((item, key) =>
                      <div key={key.toString()} data-fancybox={'featured_images'} data-src={item.image}
                           data-thumb={item.image_thumb}/>
                  )
              }
            </div>
          </div>
          {
              props.images_count > 6 &&
              <>
                <p className="m-t-10">
                  <button className="btn-link" onClick={() => handleShow('property_featured_photos_modal')}>See all
                    photos...
                  </button>
                </p>
                <CustomModal
                    modalName={'property_featured_photos_modal'}
                    className="slide_right"
                    modalSize="lg"
                    closeModal={() => {
                      handleHide()
                    }}
                    show={modalState === 'property_featured_photos_modal'}
                >
                  <ModalPropertyImages all_images={props.all_images} handleHide={handleHide}/>
                </CustomModal>
              </>
          }
        </>
    ;
  }

  const [loadAll, setLoadAll] = useState(false)

  const showAllHandler = () => {
    if (loadAll) {
      const element = document.getElementById('main-gallery');
      const scrollToYOffset = element.getBoundingClientRect().y + window.scrollY - 80;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.scrollTo({ top:scrollToYOffset, behavior: "instant"})
    }
    setLoadAll(!loadAll)
  }

  return (
      builderPropertiesGalleryMode != 1 ?
          props.images_count >= 6 &&
          <div id="pro_detail_gallery" className="row full-width no-margin pb-5">
            {viewPortResult}
          </div>
          :
          <>
            {
              !inViewport ?
                  <>
                    <section className="p-b-65" id={'main-gallery'} ref={myRef}>
                      <div className="container">
                        <div className="row clearfix">
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                          <div className={'col-4'}>
                            <Skeleton height={200} className="col-md-4 "/>
                          </div>
                        </div>
                      </div>
                    </section>
                  </>
                  :
                  <>
                    <section className="p-b-65" id={'main-gallery'}>
                      <div className="container">
                        <div className="row clearfix">
                          {props.all_images.map((item, key) => {

                                return (
                                    <>
                                      <div className={"col-xs-6 col-md-4 m-b-20" + (!loadAll && key>5 ? " d-none" : "") }>
                                        <div className="thumbnail">
                                          <GalleryItem fancybox={'featured_images'} key={item.image_id.toString()} index={key}
                                                       image={item.image_thumb} imageThumb={item.image_thumb} wrapImage={false}
                                                       galleryClassName={'col-12'} arrClassName={'ar-1-1'}/>
                                        </div>
                                      </div>
                                    </>
                                )
                              }
                          )}
                        </div>
                        {
                          props.all_images.length>5 ?
                            <div className="row clearfix text-center p-t-30 m-b-60">
                              <div className="col-12">
                                <span onClick={showAllHandler} className="btn btn-rounded btn-black btn-bordered">
                                  {
                                    loadAll ?
                                        <>Show less</>
                                        :
                                        <>Load more</>
                                  }
                                </span>
                              </div>
                            </div>
                              :
                              <></>
                        }
                      </div>
                    </section>
                  </>
            }
          </>
  )
}

export default FeaturedImages;
